import Admin from 'hive-admin';

import {
  ADMIN as FILTERS_ADMIN,
  SELLER as FILTERS_SELLER,
} from './filters';

import {
  ADMIN as COLUMNS_ADMIN,
  SELLER as COLUMNS_SELLER,
} from './columns';

import {
  ADMIN as FIELDS_ADMIN,
  SELLER as FIELDS_SELLER,
} from './fields';

import { getI18nFields } from '../../helpers/i18n';

export default [
  ['ADMIN', {
    path: '/collections',
  }],
  ['SELLER', {
    path: '/store/collections',
    archiveLoadUrl: '/collections',
  }],
].reduce(
  (pages, [forRole, config]) => {
    const [
      COLUMNS,
      FILTERS,
      FIELDS,
    ] = (
        forRole === 'ADMIN'
      ? [COLUMNS_ADMIN, FILTERS_ADMIN, FIELDS_ADMIN]
      : forRole === 'SELLER'
      ? [COLUMNS_SELLER, FILTERS_SELLER, FIELDS_SELLER]
      : []
    );
    pages.push(...Admin.compileFromLibrary(['GroupResource', {
      title: 'Collections',
      // icon: 'ordered-list',
      archiveConfig: {
        title: 'Collections',
        label: 'Collections',
        // icon: 'ordered-list',
        hidden: [
          [
            'condition.checkViewer',
            'role', '!==', forRole,
          ],
        ],
        createButtonPath: `${config.path}/create`,
      },
      singleLoadUrl: `/collections/:id/?${
        [
          'includeStoreData=true',
        ].join('&')
      }`,
      singleConfig: {
        hidden: true,
        alias: config.path,
        backButtonPaths: [config.path],
        getPageFields: getI18nFields,
      },
      singleEditConfig: {
        actions: [
          ['ActionSave', {
            handleSuccess: (data, props) => props.reload(),
          }],
          ['ActionDelete'],
        ],
      },
      singleCreateConfig: {
        headerTitle: 'New Collection',
      },
      redirect: [
        ['redirect.unauthorized'],
        [
          'redirect.checkViewer',
          'role', '!==', forRole,
            forRole === 'ADMIN'
          ? '/store/collections'
          : forRole === 'SELLER'
          ? '/collections'
          : null,
        ],
      ],
      columns: COLUMNS,
      filters: FILTERS,
      fields: FIELDS,
      ...config,
    }]).pages);
    return pages;
  },
  [],
);
